import { render, staticRenderFns } from "./phigros.vue?vue&type=template&id=7332e8b2&"
import script from "./phigros.vue?vue&type=script&lang=ts&"
export * from "./phigros.vue?vue&type=script&lang=ts&"
import style0 from "./phigros.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports